import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=56e059a8&"
import script from "./Transaction.vue?vue&type=script&lang=ts&"
export * from "./Transaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports